import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActiveCartService } from '@cart/data-access';
import { SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { DeviceService } from '@shared/services';
import { IconTypes, NavigationSourceService } from '@shared/v2';
import { CartActionsComponent } from '../cart-actions';

@Component({
  selector: 'sd-cart-header',
  imports: [SdvorIconComponent, CartActionsComponent],
  templateUrl: './cart-header.component.html',
  styleUrls: ['./cart-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartHeaderComponent {
  private deviceService = inject(DeviceService);
  private activeCartService = inject(ActiveCartService);
  private navigationSourceService = inject(NavigationSourceService);

  private cart = toSignal(this.activeCartService.getActive(), { initialValue: null });

  protected readonly iconTypes = IconTypes;
  protected readonly countItems = computed(() => this.cart()?.totalItems || 0);
  protected readonly isMobileSmDown = toSignal(this.deviceService.isMobileSmDown$, { initialValue: false });
  protected readonly isTabletMdDown = toSignal(this.deviceService.isTabletMdDown$, { initialValue: false });

  onNavigationBack(): void {
    this.navigationSourceService.goBack();
  }
}
